/// <amd-module name="Pipeline/Analytics/Common/Types" />
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { ITrendChartData } from "Analytics/Shared/TrendChart/Common/Types";
import { DataSeries } from "VSS/Features/Charts/Contracts";

export enum BuildOutcome {
    None = "None",
    Succeed = "Succeed",
    PartiallySucceeded = "PartiallySucceeded",
    Failed = "Failed",
    Canceled = "Canceled"
}

export enum BuildTaskOutcome {
    Succeeded = "Succeeded",
    SucceededWithIssues = "SucceededWithIssues",
    Failed = "Failed",
    Canceled = "Canceled",
    Skipped = "Skipped",
    Abandoned = "Abandoned"
}

export interface ITopFailingStageAndTaskData {
    stageName: string;
    stageFailureCount: number;
    taskName: string;
    failedCount: number;
}

export interface IStageMetrics {
    fullName: string;
    name: string;
    dataCount: number;
}

export interface IPipelineOutcomeReportConfiguration extends ITrendChartReportConfiguration {
    stage?: IStageMetrics;
}

export interface IPipelineOutcomeData {
    pipelineOutcomePassRateData: IPipelineOutcomePassRateData;
    trendChartData: ITrendChartData;
}

export interface IPipelineOutcomePassRateData {
    passPercentage: number;
    passedCount: number;
    failedCount: number;
    totalCount: number;
    failurePerStage?: IStageMetrics[];
}

export interface IAnalyticsChartProps {
    title: string;
    series: DataSeries[];
    xAxisLabelValues?: any[];
    yAxisTitle?: string;
    telemetryArea?: string;
}

export const PullRequestBranchPrefix = "refs/pull/";
export const PullRequestBranchPlaceHolderSK = -1;
export const PullRequestBranchName = "refs/pull/*";
